import { ReactElement, useEffect, useState } from 'react';
import { sortByOrder } from 'utils/collection-manipulation/array-sort-by';
import { EIconSize } from 'utils/constants/app/ui';
import { Game } from 'interfaces/sportsbook-data-levels';
import { EventCollapse } from 'components/EventCollapse';
import { GlobalIcon } from 'components/GlobalIcon';
import { MatchCardInline } from 'components/MatchCardInline';
import './index.less';

type TCompetitionCollapseProps = {
  onClick: (
    sportAlias: string,
    regionAlias: string,
    compId: number,
    gameId: number
  ) => void;
  compId: number;
  regionAlias: string;
  compName: string;
  isActive: boolean;
  games: Record<string, Game>;
  sportAlias: string;
  sportName: string;
  activeGameId: string;
  isFirstCompetition?: boolean;
  selectedCompetition?: string;
  comp?: { id: number; game?: Record<string, Game>; name: string };
};

export const CompetitionCollapse = ({
  onClick,
  compId,
  regionAlias,
  compName,
  isActive,
  games,
  sportAlias,
  sportName,
  isFirstCompetition,
  selectedCompetition,
  activeGameId,
  comp
}: TCompetitionCollapseProps): ReactElement => {
  const collapseDefaultActive =
    (isFirstCompetition && !selectedCompetition) || isActive;

  const [isOpen, setIsOpen] = useState(collapseDefaultActive);

  useEffect(() => {
    const selectedCompNoGameId =
      selectedCompetition && comp?.id === +selectedCompetition && !activeGameId;

    const firstSelectedGame = selectedCompNoGameId ? comp?.game || {} : games;

    if ((isFirstCompetition && !selectedCompetition) || selectedCompNoGameId) {
      const firstGame = sortByOrder(
        Object.values(firstSelectedGame),
        'start_ts'
      )?.[0];

      if (firstGame) {
        onClick(sportAlias, regionAlias, compId, firstGame.id);
      }
    }
  }, [isFirstCompetition, selectedCompetition, games]);

  return (
    <EventCollapse
      key={compId}
      title={
        <span className="competitionTitle">
          <GlobalIcon size={EIconSize._20} lib="flags" name={regionAlias} />
          <span>{compName}</span>
        </span>
      }
      defaultActive={isOpen || collapseDefaultActive}
    >
      <>
        {sortByOrder(Object.values(games), 'start_ts').map(game => (
          <MatchCardInline
            isActive={activeGameId === String(game.id)}
            key={game.id}
            game={game}
            currentSport={sportAlias}
            competitionName={compName}
            sportName={sportName}
            onClick={() => {
              setIsOpen(true);
              onClick(sportAlias, regionAlias, compId, game.id);
            }}
            longDate
          />
        ))}
      </>
    </EventCollapse>
  );
};
